import React from 'react';

import mixin from 'react-mixin';
import { forwardPropsToState } from '../../../utils/react_utils';
import LecomLabel from '../../../form/components/label/label.jsx';
import InputSelectOption from './input_select_option';
import OptionsPropsHelper from '../../../form/helpers/options_props_helper';
import RestClient from 'rest_client/rest_client';

@mixin.decorate(window.CssClassMixin)
@mixin.decorate(window.InputComponentMixin)
@forwardPropsToState([
	{prop: 'value', defaultValue: []},
	{prop: 'options', defaultValue: []}
])

export default class InputSelect extends React.Component {
	componentDidMount() {
		if (this.props.optionsUrl !== undefined) {
			const url = OptionsPropsHelper.buildOptionsUrl(this.props.optionsUrl, this.props.optionsUrlParams, true);

			RestClient.get(url)
				.then(response => this.handleOptionsRequestSuccess(response))
				.catch(err => this.handleOptionsRequestError(err));
		}
	}

	handleOptionsRequestSuccess(response) {
		let selectOptions = [];
		const options = response.entity._embedded.fieldOptions || [];

		for (let i = 0; i < options.length; i++) {
			const optionProps = options[i];
			selectOptions.push(<InputSelectOption {...optionProps} key={optionProps.name} />);
		}

		this.selectOptionsURL = selectOptions;

		this.forceUpdate();
	}

	handleOptionsRequestError(err) {
		//err
	}

	renderOptions() {
		let selectOptions = [];
		const options = this.props.options || [];
		const value = this.props.value;

		if (!options.length && value) {
			const valueSelected = value instanceof Array && value[0] ? value[0] : value;
			const optionProps = {
				name: valueSelected,
				value: valueSelected
			};

			selectOptions.push(<InputSelectOption {...optionProps} key={optionProps.name} />);

			return selectOptions;
		}

		for (let i = 0; i < options.length; i++) {
			const optionProps = options[i];
			selectOptions.push(<InputSelectOption {...optionProps} key={optionProps.name} />);
		}

		return selectOptions;
	}

	selectedValue() {
		const value = this.state.value;
		return value;
	}

	autocompleteReadOnly(){
		const readOnly = this.props.readOnly;
		const disabled = this.props.disabled;

		if(readOnly === true || disabled === true){
			return ''
		} else {
			return '▼'
		}
	}

	classNameReadOnly(){
		const readOnly = this.props.readOnly;

		if(readOnly === true)
			return ' mobile-read-only readonly-autocomplete'

		else
			return ''
	}

	render() {
		
		return (
			<div className="container-select-mobile">
				<LecomLabel {...this.propsWithoutCSS()}
					id={this.props.id}
					active={true}
					key={`lecom--label__${this.props.id}`}
					className={this.classNameReadOnly()}
				/>
				<span className="caret">{this.autocompleteReadOnly()}</span>
				<select
					id={this.props.id}
					name={this.props.name}
					value={this.selectedValue()}
					onChange={this._handleChange.bind(this)}
					disabled={this.props.disabled}
					readOnly={this.props.readOnly}
					className={`select-mobile ${this.classNameReadOnly()}`}
					ref="select"
				>
					<option value="">Selecione</option>
					{this.selectOptionsURL ? this.selectOptionsURL : this.renderOptions()}
				</select>
			</div>
		);
	}
}
